export default "__VITE_ASSET__XN6mDWMt__"